import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { getZ3KCustomControlsConfig } from '../../content/device/custom-controls/z3k';
import { getZ3KGuardZones } from '../../content/device/guard-zones/z3k';
import { getZ3KSensorsConfig } from '../../content/device/sensors/z3k';
import { getZ3KThermometersConfig } from '../../content/device/thermometers/z3k';
import { DeviceUISettingsProvider } from '../device-ui-settings';
import { useDeviceConfig } from '../device/config';
import { getTabConfig } from '../utils';
export const Z3KGuardDeviceContentProvider = memo(function Z3KGuardDeviceContentProvider(props) {
    const { children } = props;
    const { device_id, z3k_config, is_only_guard_device } = useDeviceConfig();
    const thermometers = useMemo(() => getZ3KThermometersConfig(z3k_config), [z3k_config]);
    const sensors = useMemo(() => getZ3KSensorsConfig(z3k_config), [z3k_config]);
    const custom_controls = useMemo(() => getZ3KCustomControlsConfig(device_id, z3k_config, false), [device_id, z3k_config]);
    const guard_zones = useMemo(() => getZ3KGuardZones(z3k_config), [z3k_config]);
    const full_tab_config = useMemo(() => getTabConfig({ guard_zones, thermometers, sensors, custom_controls }), [thermometers, sensors, guard_zones, custom_controls]);
    const device_tab_config = useMemo(() => {
        if (is_only_guard_device) {
            return full_tab_config;
        }
        const { guard_zones } = full_tab_config;
        return { guard_zones };
    }, [guard_zones, is_only_guard_device, full_tab_config]);
    return (_jsx(DeviceUISettingsProvider, { device_config: device_tab_config, children: children }));
});
